import flow from 'lodash/flow';
import BoardsDirectory from '@atlassian/jira-boards-main/src/index.tsx';
import withProps from '@atlassian/jira-common-with-props/src/index.tsx';
import CreateButton from '@atlassian/jira-create-boards-button/src/index.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import BoardsPage from './view.tsx';

export default flow(injectIntl, withProps({ CreateButton, BoardsDirectory }))(BoardsPage);
